<template>
  <v-container v-if="services">
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title>Service Status</v-toolbar-title>
            <v-spacer></v-spacer>
            <!-- List of totals -->

            <v-tooltip bottom v-for="(status, key) in statusMap" :key="key">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  :color="status.color"
                >
                  <v-icon>{{ status.icon }}</v-icon>
                  {{ status.label }} {{ counts[key] }}
                </v-chip>
              </template>
              <span>{{ status.text }}</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col
                v-for="(service, key) in services"
                :key="key"
                cols="6"
                sm="12"
                md="12"
                lg="6"
              >
                <v-card>
                  <v-toolbar dark color="secondary">
                    <v-toolbar-title>{{
                      service.friendly_name || service.url
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="gray" fab>
                      <v-icon :color="statusMap[service.status].color">{{
                        statusMap[service.status].icon
                      }}</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <StatusChart :service="service" />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- {{ services }} -->
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import StatusChart from "@/components/StatusChart.vue";
export default {
  components: {
    StatusChart,
  },
  name: "ServiceStatus",
  data() {
    return {
      services: [],
      counts: {
        0: 0,
        1: 0,
        2: 0,
        8: 0,
        9: 0,
      },
      statusMap: {
        0: {
          color: "blue",
          text: "Paused",
          icon: "mdi-pause",
        },
        1: {
          color: "gray",
          text: "Not Checked Yet",
          icon: "mdi-clock",
        },
        2: {
          color: "green",
          text: "Up",
          icon: "mdi-check",
        },
        8: {
          color: "purple",
          text: "Seems Down",
          icon: "mdi-alert",
        },
        9: {
          color: "red",
          text: "Down",
          icon: "mdi-alert",
        },
      },
    };
  },
  mounted() {
    this.loadData();
    setInterval(
      () => {
        this.loadData();
      }, //60 seconds
      60000
    );
  },
  methods: {
    async loadData() {
      axios.get("/api/v1/uptime").then((response) => {
        this.services = response.data;
        // Set all counts to 0
        this.counts = { 0: 0, 1: 0, 2: 0, 8: 0, 9: 0 };
        this.services.forEach((service) => {
          this.counts[service.status]++;
        });
      });
    },
  },
};
</script>
